import {CommonModule} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, RouterModule} from '@angular/router';
import {UntilDestroy} from '@ngneat/until-destroy';
import {Maintenance} from './maintenance-page.models';
import {I18NextModule} from 'angular-i18next';
import {interval, map, Observable} from 'rxjs';
import {MaintenanceService} from "mbs-ui-shared@services/maintenance.service";

@UntilDestroy()
@Component({
  selector: 'mbs-maintenance-page',
  templateUrl: './maintenance-page.component.html',
  standalone: true,
  styleUrls: ['./maintenance-page.component.scss'],
  imports: [CommonModule, I18NextModule, RouterModule]
})
export class MaintenancePageComponent implements OnInit {
  constructor(private route: ActivatedRoute, private maintenanceService: MaintenanceService) {
  }

  public maintenance: Maintenance = null;

  public dates = {
    now: new Date(),
    utc: null,
    est: null
  };

  public remainingTime: Observable<string>;
  public diff = 0;

  private intervalId: number

  private get pageUrl() {
    return this.route.snapshot.queryParamMap.get('page')
  }

  ngOnInit() {
    this.setDates();
    this.setMaintenance();
  }

  private handleMaintenance() {
    clearInterval(this.intervalId)

    if (this.maintenance) {
      this.intervalId = window.setInterval(() => {
        location.reload();
      }, 1000 * 60 * 3)
    }
  }

  private setRemainingTime() {
    this.diff = new Date(this.maintenance.endDate).getTime() - new Date().getTime();
    this.remainingTime = interval(1000).pipe(
      map(() => {
        this.diff = this.diff - 1000;

        const seconds = Math.floor(this.diff / 1000) % 60;
        const minutes = Math.floor(this.diff / 1000 / 60) % 60;
        const hours = Math.floor(this.diff / 1000 / 60 / 60);

        return `${hours}h ${minutes}m ${seconds}s`;
      })
    );
  }

  private setDates() {
    this.dates.utc = this.dates.now.toLocaleString('en-US', {timeZone: 'UTC'});
    this.dates.est = this.dates.now.toLocaleString('en-US', {timeZone: 'America/New_York'});
  }

  private setMaintenance() {
    this.maintenance = this.maintenanceService.getMaintenance(this.pageUrl)

    this.maintenance && this.setRemainingTime();
    this.handleMaintenance();
  }
}
